// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"1fef4e5c","380":"13da0add","453":"5daae68c","483":"7dbf1afd","532":"f918cd77","745":"ae6ffdc2","775":"c1fe962f","843":"bd98cac3","869":"caf11fca"}[chunkId] + ".chunk.js";
};